import { Link } from 'react-router-dom';
import '../../../App.css';

import imgBackAbout from "../../../img/2150797378.jpg";
import imgCircleAbout from "../../../img/2151224212.jpg";

const SobreNos = ({ buttonVisible }) => {
    return (
        // < !--About Start-- >
        <div className="container-fluid about bg-light py-5">
            <div className="container">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
                        <div className="about-img pb-5 ps-5">
                            <img src={imgBackAbout} className="img-fluid rounded w-100" style={{ objectFit: 'cover' }}
                                alt="" />
                            <div className="about-img-inner">
                                <img src={imgCircleAbout} className="img-fluid rounded-circle w-100 h-100" alt="" />
                            </div>
                            <div className="about-experience">Cultura Organizacional</div>
                        </div>
                    </div>
                    <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.4s">
                        <div className="section-title text-start mb-5">
                            <h4 className="sub-title pe-3 mb-0">Sobre nós</h4>
                            <h1 className="display-3 mb-4">Compromisso com a vida e o cuidado</h1>
                            <div className="mb-4">
                                <p className="text-secondary h5"><i className="fa fa-check text-primary me-2"></i>
                                    Missão:</p>
                                <p className="mb-4">Prestar cuidado pleno ao recém-nascido e à criança gravemente enferma com
                                    acolhimento, misericórdia e compaixão, buscando entendimento e compreensão
                                    das dores e sofrimentos da família.</p>
                                <p className="text-secondary h5"><i className="fa fa-check text-primary me-2"></i>
                                    Visão:</p>
                                <p className="mb-4">Ser referência em atendimento com amor, cuidado e excelência, através dos
                                    princípios cooperativistas que regem a
                                    instituição baseados em ciência e evidência, utilizando de processos, métodos e
                                    tecnologias concordantes com a
                                    literatura científica e experimentados nos mais avançados centros de atenção à criança.
                                </p>
                                <p className="text-secondary h5"><i className="fa fa-check text-primary me-2"></i>
                                    Valores:</p>
                                <p className="mb-4">Baseados nos pilares do cooperativismo: <br />
                                    ● ética
                                    ● autonomia e independência
                                    ● educação continuada
                                    ● prevenção
                                    ● informação <br />
                                    ● intercooperação
                                    ● interesse da comunidade</p>
                            </div>
                            <Link to="/Sobre" className="btn btn-primary rounded-pill text-white py-3 px-5" style={{ display: !!buttonVisible ? '' : 'none' }}>Saiba Mais</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--About End-- > */}
        </div>
    )
}
export default SobreNos;
